import {
  ITEM_DIETARY_FIELDS,
  ITEM_ALLERGEN_FIELDS,
  DIETARY_LABELS_FR,
  ALLERGEN_LABELS_FR,
  AVAILABILITY_LABELS_FR,
} from "../lib/venue-menus-client/menuItemConstants"
import AllergenIcon from "./AllergenIcon"

const CheckboxField = ({ isDarkMode, checked, onChange, label, icon = null }) => (
  <div className={isDarkMode ? "checkbox-container" : "light-checkbox-container"}>
    <label className={isDarkMode ? "checkbox-label" : "light-checkbox-label"}>
      <input
        type="checkbox"
        checked={checked || false}
        onChange={onChange}
        className={isDarkMode ? "checkbox-input" : "light-checkbox-input"}
      />
      <span className={`${isDarkMode ? "checkbox-text" : "light-checkbox-text"} inline-block relative -mt-1`}>
        {icon}
        {label}
      </span>
    </label>
  </div>
)

const MenuItemMetaFields = ({ item, index, isDarkMode, onChange, showAvailabilityExtras = false }) => (
  <>
    <p className={isDarkMode ? "form-hint" : "light-form-hint"} style={{ margin: "8px 0 4px", fontSize: "13px", fontWeight: 600 }}>
      Régime alimentaire
    </p>
    {ITEM_DIETARY_FIELDS.map((field) => (
      <CheckboxField
        key={field}
        isDarkMode={isDarkMode}
        checked={item[field]}
        label={DIETARY_LABELS_FR[field]}
        onChange={(e) => onChange(index, field, e.target.checked)}
      />
    ))}

    <p className={isDarkMode ? "form-hint" : "light-form-hint"} style={{ margin: "12px 0 4px", fontSize: "13px", fontWeight: 600 }}>
      Allergènes présents
    </p>
    <div className="allergen-fields-grid">
      {ITEM_ALLERGEN_FIELDS.map((field) => (
        <CheckboxField
          key={field}
          isDarkMode={isDarkMode}
          checked={item[field]}
          icon={<AllergenIcon field={field} size={16} className="allergen-icon-inline" />}
          label={ALLERGEN_LABELS_FR[field]}
          onChange={(e) => onChange(index, field, e.target.checked)}
        />
      ))}
    </div>

    <p className={isDarkMode ? "form-hint" : "light-form-hint"} style={{ margin: "12px 0 4px", fontSize: "13px", fontWeight: 600 }}>
      Disponibilité
    </p>
    <CheckboxField
      isDarkMode={isDarkMode}
      checked={item.isActive}
      label={AVAILABILITY_LABELS_FR.isActive}
      onChange={(e) => onChange(index, "isActive", e.target.checked)}
    />
    {showAvailabilityExtras && (
      <>
        <CheckboxField
          isDarkMode={isDarkMode}
          checked={item.commandable}
          label={AVAILABILITY_LABELS_FR.commandable}
          onChange={(e) => onChange(index, "commandable", e.target.checked)}
        />
        <CheckboxField
          isDarkMode={isDarkMode}
          checked={item.isAvailable24_7}
          label={AVAILABILITY_LABELS_FR.isAvailable24_7}
          onChange={(e) => onChange(index, "isAvailable24_7", e.target.checked)}
        />
      </>
    )}

    <style>{`
      .allergen-fields-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
        gap: 4px 12px;
        margin-bottom: 8px;
      }
      .allergen-icon-inline {
        display: inline-flex;
        margin-right: 6px;
        vertical-align: middle;
      }
    `}</style>
  </>
)

export default MenuItemMetaFields
